import { AppRole } from '@/types/role';
import { api } from './client';
import { GrantDetail, Member, MemberDetails, ScopeRef } from '@/types/member';

export const membersApi = {
  get: async (memberId: string): Promise<Member> => {
    const { data } = await api.get(`/api/v1/members/${memberId}`);
    return data;
  },

  getMembersDetails: async (organisationId: string): Promise<MemberDetails[]> => {
    const { data } = await api.get(`/api/v1/organizations/${organisationId}/members_details`);
    return data;
  },

  getMemberRoles: async (memberId: string): Promise<AppRole[]> => {
    const { data } = await api.get(`/api/v1/members/${memberId}/role`);
    return data;
  },

  deleteMember: async (organizationId: string, memberId: string) => {
    const { data } = await api.delete(`/companies/${organizationId}/members/${memberId}`);
    return data;
  },

  updateMemberRole: async (memberId: string, roleId: string) => {
    const { data } = await api.patch(`/api/v1/members/${memberId}/role/${roleId}`);
    return data;
  },

  getGrants: async (memberId: string): Promise<GrantDetail[]> => {
    const { data } = await api.get(`/api/v1/members/${memberId}/grants`);
    return data;
  },

  createGrants: async (memberId: string, roleId: string, scopes: ScopeRef[]) => {
    const { data } = await api.post(`/api/v1/members/${memberId}/grants`, {
      role_id: roleId,
      scopes: scopes,
    });
    return data;
  },

  deleteGrants: async (memberId: string, memberGrantId: string) => {
    const { data } = await api.delete(`/api/v1/members/${memberId}/grants/${memberGrantId}`);
    return data;
  },

  updateGrants: async (memberId: string, roleId: string, scopes: ScopeRef[]) => {
    const { data } = await api.put(`/api/v1/members/${memberId}/grants`, {
      role_id: roleId,
      scopes: scopes,
    });
    return data;
  }
}